.listingItem {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  background-color: var(--static-background-standard);
  height: 100%;
}

.listingImage {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  object-fit: cover;
  object-position: center;
}

.listingItemDetail {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 0.5rem;
}

.listingName {
  color: var(--static-text-standard);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}

.listingSku {
  color: var(--static-text-weak);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}

.searchInput {
  width: 24rem;
}

.rowCell {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 18px 16px;
}

.link {
  padding: 1.125rem 1rem;
  color: var(--static-text-standard);
  text-decoration: none;
  cursor: pointer;
}

.headerCell {
  background: var(--static-background-standard);
  text-align: right;
}

.button {
  padding: 18px 16px;
  height: 100%;
  width: 100%;
  background: var(--static-background-standard);
  border: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  color: var(--static-text-standard);
  white-space: nowrap;
  font-size: 14px;
}

.imageButton {
  padding: 12px 16px;
}

.rightAlign {
  text-align: right;
}

.tableContainer table th {
  /*padding: 0 !important;*/
  background: var(--static-background-standard);
}

.tableContainer table td {
  /* padding: 0 !important; */
  background-color: var(--static-background-standard);
  padding: 0 16px
}